import COSParser from "./cosParser.js";

function orderPhotos (config,unorderedPhotos) {
    const data = config.data["allContentfulDesign"].nodes[0];
    let photos = [];
    let imageOrder = data["imageOrder"];

    let conf = {
        H: "hugePhotos",
        W: "widePhotos",
        T: "tallPhotos",
    };
    let parser = new COSParser(conf);
    parser.parseOrder(imageOrder)
        .forEach(({category, index}) => {
            let photo = unorderedPhotos[category][index];
            if (photo) {
                photos.push(photo)
            }
        });
    return photos
}


export default function makeConfig(config) {
    const data = config.data["allContentfulDesign"].nodes[0];
    let imageOrder = data["imageOrder"];
    let photos = [];

    let unorderedPhotos = {
        hugePhotos: data.hugePhotos
            ? data.hugePhotos.map(photo => ({ url: photo.file.url, size: "huge",gatsbyImageData:photo.gatsbyImageData}))
            : [],
        tallPhotos: data.tallPhotos
            ? data.tallPhotos.map(photo => ({ url: photo.file.url, size: "tall",gatsbyImageData:photo.gatsbyImageData }))
            : [],
        widePhotos: data.widePhotos
            ? data.widePhotos.map(photo => ({ url: photo.file.url, size: "wide",gatsbyImageData:photo.gatsbyImageData }))
            : [],
    };
    if(imageOrder) {
        photos = orderPhotos(config,unorderedPhotos);
    }else{
        photos = [...unorderedPhotos.tallPhotos,...unorderedPhotos.hugePhotos,...unorderedPhotos.widePhotos]
    }
    let credits = ""
    if(data.credits){
        credits = data.credits?.raw ? data.credits.raw : "";
    }

    return {
        name:data.name,
        description:data.description ? data.description["childMarkdownRemark"].html : "",
        photos,
        credits,
    };
}